if($('.projects-page').length) {
    $('header').addClass('projects-header');

    $('.projects-page').imagesLoaded(function () {
        $('.grid').masonry({
            itemSelector: '.project-box'
        });
    });

    if($('.projects-menu > ul > li > .sub-menu').length) {
        $('header').addClass('submenu-active');
    }
}